import { computed, inject, Injectable, Signal } from '@angular/core';
import { Vehicule } from '../types/vehicule.types';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class VehiculeService {
  private apiService: ApiService = inject(ApiService);
  private vehicules: Signal<Vehicule[] | undefined> = this.apiService.getVehiculesRessouces.value;
  private readonly SELECTED_NAMES: string[] = ['Bike', 'Ski', 'Pedestrian', 'Rowing', 'Running'];

  get shortVehiculesList(): Signal<Vehicule[]> {
    return computed(() => {
      const vehicules = this.vehicules() ?? [];
      const selected: Vehicule[] = vehicules.filter((v) => this.SELECTED_NAMES.includes(v.name));
      const others: Vehicule[] = vehicules.filter((v) => !this.SELECTED_NAMES.includes(v.name));
      const autreVehicule: Vehicule = { id: -1, name: 'Other', slug: others[0]?.slug ?? 'k' };
      return others.length > 0 ? [...selected, autreVehicule] : selected;
    });
  }
}
